<template>
  <v-app>
    <v-app-bar fixed app>
      <v-btn icon @click="toggleDarkness"><v-icon>{{ dark? 'mdi-moon-waxing-crescent' : 'mdi-weather-sunny' }}</v-icon></v-btn>
      <v-toolbar-title class="pl-0">
        <v-btn @click="goto('/')" text large color="primary" class="display-1 text-none text-left px-1">Jo C.H.</v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-content>
      <div class="scroller">
        <v-fade-transition mode="out-in">
          <router-view></router-view>
        </v-fade-transition>
      </div>
    </v-content>

    <v-footer
      fixed
      padless
      app
    >
      <v-card
        flat
        tile
        width="100%"
        class="text-center"
      >
        <v-card-text class="py-1">
          <v-btn
            color="primary"
            class="mx-4"
            icon
            href='https://twitter.com/jo_devs'
          >
            <v-icon size="24px">mdi-twitter</v-icon>
          </v-btn>
          <v-btn
            color="primary"
            class="mx-4"
            icon
            href="https://github.com/JoeCharlesH"
          >
            <v-icon size="24px">mdi-github-circle</v-icon>
          </v-btn>
          <v-btn
            color="primary"
            class="mx-4"
            icon
            href="https://www.youtube.com/channel/UCXw73k80B-8GOenIZspkPSA"
          >
            <v-icon size="24px">mdi-youtube</v-icon>
          </v-btn>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text class="py-1">
          {{ new Date().getFullYear() }} — <strong>Joseph Charles Hooker</strong><br>
          <strong>joe.ch.dev@gmail.com</strong>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  data: () => ({
    //
  }),
  computed: {
    dark () {
      return this.$vuetify.theme.dark
    }
  },
  methods: {
    goto (path) {
      this.$router.push(path)
    },
    toggleDarkness () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
    }
  }
}
</script>

<style>
  html {
    overflow: hidden !important;
  }

  .v-content {
    max-height: 100vh !important;
  }

  .scroller {
    height: 100%;
    overflow-y: auto;
    backface-visibility: hidden;
  }
</style>
